var React = require('react');

function HackerNewsSquare (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"}));
}

HackerNewsSquare.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = HackerNewsSquare;

HackerNewsSquare.default = HackerNewsSquare;
